import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../components/TemplateDashboard";
import CmiAntiguosAlumnosContent from './components/CmiAntiguosAlumnosContent';

const CmiAntiguosAlumnosListado = () => {

    return (
        <>

            <TemplateDashboard>
                <CmiAntiguosAlumnosContent />
            </TemplateDashboard>

        </>
    )
};

export default CmiAntiguosAlumnosListado;